import React from "react";
import { HiViewGrid } from "react-icons/hi";
import { HiDotsCircleHorizontal } from "react-icons/hi";
import { useMangroveViewModeSelector } from "../../../store/projects/selectors";
import { setMangroveViewModeAction } from "../../../store/projects/actions";
import { dispatch } from "../../../store";

const mangroveViewOptions = [
  {
    code: "districts" as const,
    icon: <HiViewGrid size={18} />,
    name: "Default",
    description: "View projects by districts",
  },
  {
    code: "aggregations" as const,
    icon: <HiDotsCircleHorizontal size={18} />,
    name: "Aggregated",
    description: "View projects by states",
  },
];

interface MangroveViewSelectorProps {
  className?: string;
}

export const MangroveViewSelector: React.FC<MangroveViewSelectorProps> = ({ className = "" }) => {
  const currentViewMode = useMangroveViewModeSelector();

  const handleViewChange = (viewMode: "districts" | "aggregations") => {
    dispatch(setMangroveViewModeAction(viewMode));
  };

  return (
    <div className={`flex gap-1 ${className}`}>
      {mangroveViewOptions.map((option) => {
        const isSelected = option.code === currentViewMode;

        return (
          <button
            key={option.code}
            onClick={() => handleViewChange(option.code)}
            className={`flex items-center gap-2 rounded-md px-3 py-1 text-sm font-medium transition-colors ${
              isSelected
                ? "bg-gray-100 text-black shadow"
                : "bg-transparent text-gray-700 hover:bg-gray-100"
            }`}
            title={option.description}
          >
            {option.icon}
            <span>{option.name}</span>
          </button>
        );
      })}
    </div>
  );
};

export default MangroveViewSelector;
